import { Button, IconArrowLeft, IconArrowRight } from 'uikit';

import type { IHeaderParams } from 'ag-grid-community';
import type React from 'react';
import { useState, useCallback, useEffect } from 'react';

import Styles from './CollapseHeaderButton.module.css';

interface ICollapseHeaderButton extends IHeaderParams {
    collapseKeys: string[];
}

export const CollapseHeaderButton: React.FC<ICollapseHeaderButton> = (props) => {
    const { collapseKeys, api } = props;

    const [isExpanded, setIsExpanded] = useState(true);

    useEffect(() => {
        api.setColumnsVisible(collapseKeys, !isExpanded);
    }, [api, collapseKeys, isExpanded]);

    const onExpandCollapseClick = useCallback(() => {
        setIsExpanded((prev) => {
            api.setColumnsVisible(collapseKeys, !prev);

            return !prev;
        });
    }, [api, collapseKeys]);

    return (
        <div className={Styles.WrapperCollapse}>
            <Button
                label="Всего"
                view="clear"
                iconRight={isExpanded ? IconArrowRight : IconArrowLeft}
                onClick={onExpandCollapseClick}
                size="xs"
                form="brick"
            />
        </div>
    );
};

CollapseHeaderButton.displayName = 'CollapseHeaderButton';
